import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 2",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1H13",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgIconMinus;
